import { filter, takeUntil } from 'rxjs/operators';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { ConversationPopupComponent } from '../conversation-popup/conversation-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { Constant } from 'src/app/constant/constant';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { AddSiteVisitComponent } from 'src/app/pages/crm/add-site-visit/add-site-visit.component';

@Component({
  selector: 'calsoft-task-new',
  templateUrl: './task-new.component.html',
  styleUrls: ['./task-new.component.scss']
})
export class TaskNewComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  @Input() type: any;

  @Input() activityList: any = [];

  @Input() entityId: any = [];

  @Input() templateDisplayed: any;

  @Input() crmType: any;

  @Input() total: any;


  activeTaskFilter: string = 'all';
  init: boolean;

  leadActivityList: any = [];
  activityId: any;
  textAccount: string;

  @Input() onScrollValue: boolean = true;

  @Input() leadActivityListFinal: any;

  @Input() spinner: boolean = false;

  @Input() totalSize: any;

  @Input() page: any;

  @Input() taskType: any;

  ngOnInit(): void {

    this.textAccount = 'OK';

  }
  constructor(private route: ActivatedRoute,
    private dialog: MatDialog,
    private leadActivityService: LeadActivityService,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef
    , private router: Router) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }



  addLeadActivity(activityType: string, activityId, leadObject: any, taskType: any) {
    if (leadObject && this.isSiteVisit(leadObject)) {
      this.openSiteVisitPopup(leadObject);
      return;
    }
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "1",
          "leadId": this.entityId,
          "activityId": activityId,
          "leadObject": leadObject,
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": this.type,
          "taskType": taskType,

        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          console.log("result", result);


          this.getAllLeadActivity(this.entityId);

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.entityId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "1",
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": this.type,
          "taskType": taskType
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getAllLeadActivity(this.entityId);

        }


      });
    }

  }


  addLeadActivityone(activityType: string, activityId, leadObject: any) {
    if (leadObject && this.isSiteVisit(leadObject)) {
      this.openSiteVisitPopup(leadObject);
      return;
    }
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "1",
          "leadId": this.entityId,
          "activityId": activityId,
          "leadObject": leadObject,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.getAllLeadActivity(this.entityId);

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.entityId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.getAllLeadActivity(this.entityId);

        }


      });
    }

  }

  getAllLeadActivity(leadId) {

    this.leadActivityService.getAllLeadActivityByPageable(0, 10, 'id,desc', leadId, this.type).subscribe(
      data => {

        this.totalSize = data["totalPages"];

        this.activityList = [...data['content']];
        this.leadActivityList = [...data['content']];
        this.cd.detectChanges();


      },
      error => {
        this.onScrollValue = false;


      })
  }

  setStatus(activityType: string, activityId, leadObject: any) {
    // if (window.innerWidth > 768) {

    //   let dialogRef = this.dialog.open(MarkAsCompleteStatusComponent, {
    //     width: '790px',
    //     disableClose: true,
    //     data: {
    //       "activityType": activityType,
    //       "type": "lead",
    //       "leadId": this.leadId,
    //       "activityId": activityId,
    //       "leadObject": leadObject,
    //       "templateDisplayed": this.templateDisplayed,
    //       "taskSaveType": 1
    //     }
    //   });

    //   dialogRef.disableClose = true;
    //   dialogRef.afterClosed().subscribe(result => {
    //     if (result['event'] == 'add') {

    //       this.getAllLeadActivity(this.leadId);

    //     }



    //   });

    // }
    // else {
    //   let dialogRef = this.dialog.open(MarkAsCompleteStatusComponent, {
    //     minWidth: '100vw', height: '100vh',
    //     data: {
    //       "activityType": activityType,
    //       "leadId": this.leadId,
    //       "activityId": activityId,
    //       "leadObject": leadObject,
    //       "type": "lead",
    //       "templateDisplayed": this.templateDisplayed,
    //       "taskSaveType": 1
    //     },
    //   });

    //   dialogRef.disableClose = true;
    //   dialogRef.afterClosed().subscribe(result => {
    //     if (result['event'] == 'add') {

    //       this.getAllLeadActivity(this.leadId);

    //     }


    //   });
    // }

  }

  isOverdue(task: any): boolean {

    let value = new Date(task.dueDateTime) < new Date()

    return value;
  }

  isSiteVisit(task: any): boolean {
    if (!task) return false;
    const type = (task.activityType || task.type || task.activityTypeName || '').toString().toLowerCase().trim();
    const subject = (task.subject || '').toString().toLowerCase().trim();
    const outcome = (task.phoneCallOutcome || '').toString().toLowerCase().trim();
    return type === 'sitevisit' || type === 'site visit' || type === 'site_visit' || subject.includes('site visit') || subject.includes('sitevisit') || outcome.includes('site visit') || outcome.includes('sitevisit');
  }

  openSiteVisitPopup(task: any) {
    const dialogData = {
      "leadId": (this as any).entityId || task?.leadId || task?.entityId,
      "leadName": task?.leadName || task?.customerName || task?.name || '',
      "assignedAgentId": task?.ownerId || localStorage.getItem('ID'),
      "activityId": task?.id,
      "title": task?.subject || 'Site Visit',
      "description": task?.notes || '',
      "startDateTime": task?.dueDateTime || task?.createdDate,
      "task": task,
      "siteVisitId": task?.siteVisitId || task?.id || task?.activityId,
      "propertyId": task?.propertyId
    };

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(AddSiteVisitComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: dialogData
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && (result['event'] == 'add' || result['event'] == 'update')) {
          this.getAllLeadActivity(this.entityId);
        }
      });
    } else {
      let dialogRef = this.dialog.open(AddSiteVisitComponent, {
        minWidth: '100vw',
        height: '100vh',
        disableClose: true,
        data: dialogData
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && (result['event'] == 'add' || result['event'] == 'update')) {
          this.getAllLeadActivity(this.entityId);
        }
      });
    }
  }

  @ViewChild('delete') delete: TemplateRef<any>;

  deleteLeadDialog(activityId) {

    this.activityId = activityId;
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,

    });
    dialogRef.disableClose = true;
  }



  submit() {
    this.deleteAllLead(this.activityId);
    this.dialog.closeAll();
    this.init = false;
    this.getAllLeadActivity(this.entityId);
  }

  deleteAllLead(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.leadActivityService.deleteByLeadActivityId(this.activityId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadActivity(this.entityId);
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })
  }

  @Output() scrollChange = new EventEmitter<void>();

  onScroll() {

    if (this.page < this.totalSize) {
      this.scrollChange.emit()
    }

  }


  expanded = false;

  toggleNotes(task: any, event: Event): void {
    event.stopPropagation();
    task.expanded = !task.expanded;
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
